import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bulb",
  "use": "bulb-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"bulb\"><path d=\"M8.156 15.846A7.689 7.689 0 0 1 12 1.5a7.689 7.689 0 0 1 3.844 14.346v2.716a.75.75 0 0 1-.75.75H8.906a.75.75 0 0 1-.75-.75v-2.716Zm1.031 4.966h5.626c.103 0 .187.085.187.188v.75a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75V21c0-.103.084-.188.188-.188Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol